import reducer, { KansatsuKirokuObsrecState } from "./reducers";
import * as kansatsuKirokuObsrecOperations from "./operations";

export {
  kansatsuKirokuObsrecOperations, // operations の export すべて
  KansatsuKirokuObsrecState // reducer が 利用している型
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/kansatsuKirokuObsrec/index.ts